export const CACHE_TTL = 10 * 60 * 1000;

// Padronização (React Query) para o fluxo de Resume do produto
export const STALE_TIME = CACHE_TTL; // 10min
export const CACHE_TIME = 30 * 60 * 1000; // 30min
export const STALE_TIME_SHORT = 2 * 60 * 1000; // 2min (ex.: links)
